import React from 'react';
import PropTypes from 'prop-types';
import { Box, HStack, VStack, Text, Image, Link as CLink, Stack, AspectRatio } from '@chakra-ui/react';

import withEulaRestrictions from '../license/withEulaRestrictions';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import { Container } from 'reactstrap';

export class DashboardPage extends React.Component {
  static get propTypes() {
    return {
      title: PropTypes.string,
      location: PropTypes.object,
    };
  }

  getBreadCrumbs(title) {
    const { pathname } = this.props.location;
    return getBreadCrumbs(title, pathname, []);
  }

  render() {
    return (
      <Box height={'100%'} width={'100%'} pt={{ base: 10, md: 20 }}>
        <Container>
          <Stack
            direction={{ base: 'column', md: 'row' }}
            justifyContent={'space-between'}
            spacing={{ base: 8, md: 0 }}
          >
            <HStack>
              <VStack>
                <CLink href="https://radstar.accustarlabs.com/knowledge-base/account-setup/">
                  <Image src={'/content/dashboard/icon-getting-started.png'} objectFit="cover" />
                </CLink>
              </VStack>
              <VStack>
                <CLink href="https://radstar.accustarlabs.com/downloads/ ">
                  <Image src={'/content/dashboard/icon-downloads.png'} objectFit="cover" />
                </CLink>
              </VStack>
            </HStack>

            <HStack>
              <VStack>
                <CLink href="https://www.radonaway.com/products/radon-testing/radstaralpha.php">
                  <Image src={'/content/dashboard/icon-purchasing.png'} objectFit="cover" />
                </CLink>
              </VStack>
              <VStack>
                <CLink href="http://www.radstaralpha.com">
                  <Image src={'/content/dashboard/icon-support.png'} objectFit="cover" />
                </CLink>
              </VStack>
            </HStack>
          </Stack>
          <Stack
            spacing={20}
            mt={20}
            px={{ base: 0, md: 10 }}
            direction={{ base: 'column', lg: 'row' }}
            justifyContent={'space-evenly'}
          >
            <CLink
              href="https://radstar.accustarlabs.com/knowledge-base/reporting-compliance-update/"
              _hover={{
                textDecoration: 'none',
              }}
            >
              <VStack spacing={0} borderWidth={2} borderColor={'#000'}>
                <Image src={'/content/dashboard/cta-fieldmgmt.png'} maxH={200} />
                <Text
                  fontSize={'16px'}
                  textTransform={'uppercase'}
                  color="#fff"
                  bgColor={'rgb(173, 31, 44)'}
                  width={'100%'}
                  height={'100%'}
                  lineHeight={'50px'}
                  fontWeight={700}
                >
                  Reporting Compliance Update!
                </Text>
              </VStack>
            </CLink>
            <CLink
              href="https://radstar.accustarlabs.com/article-categories/inspection-support-network-isn-integration/"
              _hover={{
                textDecoration: 'none',
              }}
            >
              <VStack spacing={0} borderWidth={2} borderColor={'#000'}>
                <Image src={'/content/dashboard/cta-isn.png'} maxH={200} />
                <Text
                  fontSize={'16px'}
                  textTransform={'uppercase'}
                  color="#fff"
                  bgColor={'rgb(173, 31, 44)'}
                  width={'100%'}
                  height={'100%'}
                  lineHeight={'50px'}
                  fontWeight={700}
                  textDecoration={'none'}
                >
                  New! ISN Integration
                </Text>
              </VStack>
            </CLink>
          </Stack>
          <CLink
            href="https://radstar.accustarlabs.com/knowledge-base/reporting-compliance-update/"
            _hover={{
              textDecoration: 'none',
            }}
          >
            <Text
              fontSize={'16px'}
              textTransform={'uppercase'}
              color="#fff"
              bgColor={'rgb(173, 31, 44)'}
              width={'100%'}
              height={'100%'}
              lineHeight={{ base: '24px', md: '50px' }}
              fontWeight={700}
              mt={10}
            >
              3/9/2022: RadonAway&apos;s new Reporting and Compliance Update - Click here for details &raquo;
            </Text>
          </CLink>
          <Box mb={5}>
            <Text fontSize={'1.5rem'} color="#000" lineHeight={'50px'} fontWeight={700} mt={5} textAlign={'left'}>
              Welcome to the Radon Management Cloud
            </Text>
            <Text textAlign={'left'}>
              The Radon Management Cloud is your centralized management tool for your continuous radon monitors. All
              tests downloaded using the RadStar mobile and desktop applications will sync to this Radon Management
              Cloud. Compatible continuous radon monitors that you can sync to this Cloud service include:
            </Text>

            <Text as={'ul'} pl={'40px'} my={5}>
              <Text as="li" textAlign={'left'}>
                The new Radstar Alpha Series, models α310, α516 and α830
              </Text>
              <Text as="li" textAlign={'left'}>
                RadStar RS300, RadStar RS800
              </Text>
              <Text as="li" textAlign={'left'}>
                Sun Nuclear 1027 devices
              </Text>
            </Text>

            <Text textAlign={'left'}>
              Use this website to manage your company profile, users, and report templates.
            </Text>
          </Box>
          <HStack spacing={2} justifyContent={'center'} mb={5}>
            <CLink
              href="https://apps.apple.com/us/app/radstar-alpha-series/id1434038140?mt=8"
              isExternal
              _focus={{ boxShadow: 'none ' }}
            >
              <Image src={'/content/dashboard/app-ios.png'} maxWidth={'150px'} maxH={'44px'} />
            </CLink>
            <CLink
              href="https://play.google.com/store/apps/details?id=com.spruce&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              isExternal
              _focus={{ boxShadow: 'none ' }}
            >
              <Image src={'/content/dashboard/app-android.png'} maxWidth={'150px'} maxH={'44px'} />
            </CLink>
          </HStack>
        </Container>
      </Box>
    );
  }
}

export default withEulaRestrictions(DashboardPage);



// WEBPACK FOOTER //
// src/components/dashboard/DashboardPage.jsx